import moment from "moment";
import React, { FC } from "react";
import { GridColDef } from "@material-ui/data-grid";

import BaseDataGrid from "../../../../components/modules/BaseDataGrid";
import BillingLogsDashboardToolbar from "./BillingLogsDashboardToolbar";
import classes from "./BillingLogsDashboard.module.scss";
import { BillingLogType } from "../../../../types/advertiserTypes";

type BillingLogsDashboardProps = {
  billingLogs: BillingLogType[];
};

const BillingLogsDashboard: FC<BillingLogsDashboardProps> = ({ billingLogs }) => {
  const columns: GridColDef[] = [
    { field: "date", headerName: "Date", width: 200 },
    { field: "type", headerName: "Type", width: 150 },
    { field: "source", headerName: "Source", width: 150 },
    {
      field: "amount",
      headerName: "Amount",
      width: 200,
      sortComparator: (v1, v2) => {
        const typedV1 = v1 as string;
        const typedV2 = v2 as string;
        return Number(typedV1.slice(1)) - Number(typedV2.slice(1));
      },
    },
    { field: "description", headerName: "Description", width: 250 },
    { field: "campaignName", headerName: "Campaign Name", width: 250 },
    { field: "campaignId", headerName: "Campaign Id", width: 250 },
    { field: "advertiserId", headerName: "Advertiser Id", width: 250 },
    { field: "advertiserName", headerName: "Advertiser Name", width: 250 },
    { field: "cardLast4", headerName: "Card Last 4 Digits", width: 250 },
    { field: "statementDescriptor", headerName: "Statement Descriptor", width: 250 },
  ];

  const rows = billingLogs.map(
    (
      {
        brandgenCampaignId,
        date,
        type,
        source,
        amount,
        description,
        campaignName,
        brandgenAdvertiserId,
        advertiserName,
        cardLast4,
        statementDescriptor,
      },
      index,
    ) => ({
      id: `${brandgenCampaignId}-${index}`,
      date: moment(date).format("MMM Do YYYY, h:mm:ss a"),
      type,
      source,
      amount: `$${Number.isFinite(amount) ? amount.toFixed(2) : amount}`,
      description,
      campaignId: brandgenCampaignId,
      campaignName,
      advertiserId: brandgenAdvertiserId,
      advertiserName,
      cardLast4,
      statementDescriptor,
    }),
  );

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.dashboardContainer}>
          <div className={classes.dashboard}>
            <BaseDataGrid
              columns={columns}
              rows={rows}
              components={{
                Toolbar: BillingLogsDashboardToolbar,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingLogsDashboard;
